export default "__VITE_ASSET__d9DgzXaM__"